<template>
  <!-- Modal other files -->
  <div
    class="modal fade"
    id="us-tax-confirmation"
    tabindex="-1"
    role="dialog"
    aria-labelledby="usTaxConfirmation"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div>
          <div class="modal-header">
            <span class="modal-title-new" id="termsLabel">{{
              $t('Vergi Paketi ile devam etmek istemediğinize emin misiniz')
            }}</span>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body modal-body-min">
            <div class="alert-field-new">
              <div>
                <img src="/img/icons/goal.svg" alt="" />
              </div>
              <span class="alert-text-new">
                {{
                  $t(
                    'Vergi paketini beyan döneminden önce şimdi satın alarak $899 yerine $699 ödeyin. $200 tasarruf edin ve vergi süreçlerinizi güvence altına alın'
                  )
                }}
              </span>
            </div>
            <div class="features-field">
              <div class="features-item" v-for="(feature, index) in features" :key="index">
                <div>
                  <div class="features-header-item">{{ feature.header }}</div>
                  <div class="features-text-item">{{ feature.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer wrap-footer">
          <button @click="cancel" type="button" class="btn button-type-outline-light" data-dismiss="modal">
            {{ $t('Evet, Eklemeden Devam Etmek İstiyorum') }}
          </button>
          <button @click="confirm" type="button" data-dismiss="modal" class="btn btn-mukellef">
            {{ $t('Vergi Paketi Ekleyerek Devam Et') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'usTaxConfirmation',
  props: {
    features: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="less" scoped>
.modal-dialog {
  max-width: 659px !important;
  padding: 8px !important;
}
.alert-field-new {
  background: rgba(0, 170, 107, 0.1);
  border-radius: 12px;
  border: 1px solid #ddd;
  padding: 16px;
  display: flex;
  gap: 8px;
}

.modal-title-new {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  font-weight: 500;
  color: black;
}

.features-field {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 24px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
.features-item {
  grid-column: span 1 / span 1;
}
.features-item {
  background: #f9f9f9;
  border: 1px solid rgba(221, 221, 221, 0.87);
  border-radius: 12px;
  padding: 16px;

  .features-header-item {
    font-size: 14px;
    color: black;
    line-height: 21px;
    font-weight: 500;
  }
  .features-text-item {
    margin-top: 8px;
    font-size: 14px;
    color: black;
    line-height: 21px;
  }
}
</style>
